var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83817 3.92773C4.54593 3.92773 2.60836 6.2984 1.78158 7.62561C1.55366 7.99149 1.43969 8.17444 1.45103 8.48037C1.46237 8.78631 1.59407 8.96646 1.85745 9.32677C2.82039 10.6441 4.98246 13.0719 7.83817 13.0719C10.6939 13.0719 12.856 10.6441 13.8189 9.32677C14.0823 8.96646 14.214 8.78631 14.2253 8.48037C14.2367 8.17444 14.1227 7.99149 13.8948 7.62561C13.068 6.2984 11.1304 3.92773 7.83817 3.92773Z",
    stroke: "white",
    strokeOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.66211,
    r: 3,
    fill: "white",
    fillOpacity: 0.8,
    stroke: "white",
    strokeOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLight);
export default __webpack_public_path__ + "static/media/Eye_light.5700b1060a27a3854b34f4ff9b873393.svg";
export { ForwardRef as ReactComponent };